import { BusinessLineName } from '@common/models/Enums';
import { DateTime } from 'luxon';

/**
 * Find all elements in which at least one of the specified properties includes the provided query string
 * @param query The query string
 * @param arr An array of T to filter
 * @param properties The properties of T on which to filter
 * @returns A filtered array of T
 */
export function filterForQuery<T>(
  query: string,
  arr: T[],
  properties: Array<keyof T>,
): T[] {
  if (query === '') return arr;
  const queryLower = query.toLowerCase();
  return arr.filter((a) =>
    properties.some((property) => {
      const value = a[property];
      if (property === 'hospitalName') {
        return typeColumnFilter(value as string, queryLower);
      }

      return (
        value &&
        filterStrategies[
          DateTime.isDateTime(value) ? 'dateTime' : typeof value
        ](value, queryLower)
      );
    }),
  );
}

function stringNumberStrategy<T>(value: keyof T, queryLower: string) {
  return value.toString().toLowerCase().includes(queryLower);
}

function dateTimeStrategy(value: DateTime, queryLower: string) {
  return value.toLocaleString(DateTime.DATE_SHORT).includes(queryLower);
}

function typeColumnFilter(value: string, queryLower: string) {
  return value
    ? BusinessLineName.Hospital.toLowerCase().includes(queryLower)
    : BusinessLineName.Clinic.toLowerCase().includes(queryLower);
}

const filterStrategies: {
  [key: string]: <T>(value: T | DateTime, queryLower: string) => void;
} = {
  string: stringNumberStrategy,
  number: stringNumberStrategy,
  dateTime: dateTimeStrategy,
};
